export const config = {
  defaultRequestLimit: 7000,
};
